var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_127_117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.0002 36.5204C68.5906 41.0075 75.3145 21.4102 63.0002 15.6771C54.324 12.0892 46.3716 20.7919 51.524 28.9887C39.3335 5.2976 81.3906 6.88075 74.6287 32.9138C72.0859 41.8131 62.0383 47.1434 52.9526 45.401C46.543 44.1176 48.6668 34.9653 55.0097 36.5297L55.0002 36.5204Z",
    fill: "#DB9A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0095 7.85507C77.1524 17.4289 61.8572 17.4289 62 7.85507C61.8572 -1.71878 77.1524 -1.71878 77.0095 7.85507Z",
    fill: "#DB9A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4477 29.5039C41.0096 16.1361 21.0858 9.52243 15.2572 21.6349C11.6096 30.169 20.4572 37.9911 28.7906 32.9231C4.70486 44.9138 6.31439 3.5458 32.7715 10.1969C41.8192 12.6981 47.2382 22.5811 45.4668 31.5179C44.162 37.8224 34.8572 35.7334 36.4477 29.4945V29.5039Z",
    fill: "#DB9A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30488 7.85498C17.0382 7.71447 17.0382 22.7591 7.30488 22.6186C-2.42845 22.7591 -2.42845 7.71447 7.30488 7.85498Z",
    fill: "#DB9A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6762 48.127C20.8286 45.0169 12.6 55.0311 17.5238 63.996C18.6286 66.1506 20.4096 68.0335 22.6762 68.9797C27.1048 70.9937 34.2191 68.9422 35.4857 63.7806C36.1429 61.1576 35.4286 58.2161 34.1524 55.6681C36.6476 59.1529 37.9524 64.5862 34.8 68.249C23.0762 80.2866 6.67622 65.804 11.0476 51.743C13.5905 42.8436 23.6381 37.5133 32.7238 39.2557C39.1334 40.5391 37.0096 49.6914 30.6667 48.127H30.6762Z",
    fill: "#DB9A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.181 84.1742C20.3258 84.1742 23.6858 80.8692 23.6858 76.7924C23.6858 72.7155 20.3258 69.4106 16.181 69.4106C12.0363 69.4106 8.67627 72.7155 8.67627 76.7924C8.67627 80.8692 12.0363 84.1742 16.181 84.1742Z",
    fill: "#DB9A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3431 54.1317C45.1812 63.818 55.3621 71.9118 64.4764 67.0686C66.6669 65.982 68.5812 64.2302 69.5431 62.0007C71.5907 57.6447 69.505 50.6469 64.2574 49.401C61.5907 48.7547 58.6002 49.4572 56.0097 50.7125C59.5526 48.2582 65.0764 46.9748 68.8002 50.0755C81.0383 61.6072 66.3145 77.7385 52.0193 73.4387C42.9716 70.9375 37.5526 61.0545 39.324 52.1177C40.6288 45.8132 49.9336 47.9022 48.3431 54.1411V54.1317Z",
    fill: "#DB9A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4955 75.7713C81.6403 75.7713 85.0002 72.4663 85.0002 68.3895C85.0002 64.3126 81.6403 61.0077 77.4955 61.0077C73.3507 61.0077 69.9907 64.3126 69.9907 68.3895C69.9907 72.4663 73.3507 75.7713 77.4955 75.7713Z",
    fill: "#DB9A62"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_127_117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 83.5042,
    fill: "white",
    transform: "translate(0 0.669922)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotion);
export default __webpack_public_path__ + "static/media/promotion.ce4b69032fb5a190b66c31e2bc390dd2.svg";
export { ForwardRef as ReactComponent };